import { Record, Set } from 'immutable';
import { EventSearchFilter } from './event-filter';

const EventSearchTextRecord = Record({
  searchText: ''
});

export class EventSearchText extends EventSearchTextRecord {
  searchText: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-search-text.ts